<template>
	<div>
		<egranty-section-divider text="Terminy płatności"/>
		<v-btn
			label="Dodaj"
			for="invoice-form-payment-dates-add"
			id="invoice-form-payment-dates-add"

			@click="addPaymentDate">dodaj
		</v-btn>

		<v-layout v-for="(paymentDate, index) in invoice.paymentDates" :key="index">
			<v-flex sm3>
				<egranty-date-picker
					required
					v-model="paymentDate.date">
				</egranty-date-picker>
			</v-flex>
			<egranty-icon-button
				color="lightred"
				icon="delete"
				label="Usuń"
				large
				for="invoice-form-payment-dates-delete"
				id="invoice-form-payment-dates-delete"
				@click="removePaymentDate(index)"
			></egranty-icon-button>
		</v-layout>
	</div>
</template>
<script>
	import EgrantyDatePicker from "../../../../genericComponents/EgrantyDatePicker";
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";

	export default {
		name: "InvoiceFormPaymentDates",

		components: {EgrantySectionDivider, EgrantyDatePicker, EgrantyIconButton},

		props: {
			invoice: {
				type: Object, default: () => {
				}, required: true
			},
		},

		methods: {
			addPaymentDate() {
				this.invoice.paymentDates.push({date: ""});
			},

			removePaymentDate(index) {
				this.$delete(this.invoice.paymentDates, index);
			},
		},
	};
</script>
